import { useTranslation } from '@thoughtspot/i18n';
import { Checkbox } from '@thoughtspot/radiant-react/widgets/checkbox';
import { FormControl } from '@thoughtspot/radiant-react/widgets/form-control';
import { Select } from '@thoughtspot/radiant-react/widgets/select';
import cx from 'classnames';
import React, { useState } from 'react';
import { TranslationKeys } from '../../constant';
import styles from '../configuration-modal.module.scss';
import { testIds } from '../configuration-modal.util';
const BranchSelectionForm = props => {
    const { t } = useTranslation();
    const { branches, configBranches, formRef, onInputChange } = props;
    const isOfAllOrgType = props.isOfAllOrgType || false;
    const [enableVersionHistory, setEnableVersionHistory] = useState(formRef?.current?.enableVersionHistory ?? false);
    const handleBranchChange = (selectedBranch) => {
        formRef.current.branch = selectedBranch.id;
        if (isOfAllOrgType)
            onInputChange();
    };
    const handleGuidBranchChange = (selectedBranch) => {
        formRef.current.guidBranch = selectedBranch.id;
        if (isOfAllOrgType)
            onInputChange();
    };
    const toggleVersionHistory = (e) => {
        setEnableVersionHistory(e.target.checked);
        formRef.current.enableVersionHistory = e.target.checked;
        if (isOfAllOrgType)
            onInputChange();
    };
    return (React.createElement("form", { action: "", className: cx({
            [styles.configurationModalBranchSelectionForm__extraMargin]: isOfAllOrgType,
        }) },
        React.createElement(FormControl, { label: t(TranslationKeys.VCS_ADMIN_CONFIG_MODAL_BRANCH_LABEL) },
            React.createElement(Select.Dropdown, { id: "branch-select", "data-testid": testIds.branch, optionsGroups: branches, placeholder: t(TranslationKeys.VCS_ADMIN_CONFIG_MODAL_BRANCH_PLACEHOLDER), onChange: handleBranchChange, isSearchEnabled: true, selectedOptions: [formRef.current.branch], emptyText: t(TranslationKeys.VCS_ADMIN_CONFIG_MODAL_NO_BRANCH_PLACEHOLDER) })),
        React.createElement(FormControl, { label: t(TranslationKeys.VCS_ADMIN_CONFIG_MODAL_GUID_LABEL), className: (styles.configurationModalBranchSelectionForm__guidSelect,
                cx({
                    [styles.configurationModalBranchSelectionForm__guidAllOrg]: isOfAllOrgType,
                })) },
            React.createElement(Select.Dropdown, { id: "guid-branch-select", "data-testid": testIds.guidBranch, optionsGroups: configBranches, placeholder: t(TranslationKeys.VCS_ADMIN_CONFIG_MODAL_GUID_PLACEHOLDER), onChange: handleGuidBranchChange, isSearchEnabled: true, selectedOptions: [formRef.current.guidBranch], emptyText: t(TranslationKeys.VCS_ADMIN_CONFIG_MODAL_NO_BRANCH_PLACEHOLDER) })),
        React.createElement(Checkbox, { id: "version-history-checkbox", "data-testid": testIds.enableVersionHistory, label: t(TranslationKeys.VCS_ADMIN_CONFIG_MODAL_VERSION_HISTORY_LABEL), checked: isOfAllOrgType
                ? formRef.current.enableVersionHistory
                : enableVersionHistory, onChange: toggleVersionHistory })));
};
export default BranchSelectionForm;
//# sourceMappingURL=branch-selection-form.js.map